import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

const DataGrid = {
    selections: [],
    resultStateSelections: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号', width: 75},

    {key:'orgName', label: '部门名称', width: 150},
    {key:'evalName', label: '评价项目', width: 130},
    {key:'employeeCode', label: '被评教师工号', width: 120},
    {key:'employeeName', label: '被评教师名称', width: 120},
    {key:'evalEmCode', label: '评价人工号', width: 120},
    {key:'evalEmName', label: '评价人姓名', width: 120},
    {key:'classesName', label: '班级名称', width: 120},
    {key:'courseName', label: '课程名称', width: 150},
    {key:'resultScore', label: '分数', width: 70},
    {key:'weekNum', label: '周次', width: 80},
    {key:'weekName', label: '星期', width: 80},
    {key:'calendar', label: '听课日期', width: 120, render: (value)=> value ? moment(new Date(value)).format('YYYY/MM/DD') :""},
    {key:'bgTermName', label: '开始学期', width: 130},
    {key:'endTermName', label: '结束学期', width: 130}
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/result/list/total/date', Object.assign(defaultsParams, keywords))
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta
        };
    })
    .then(response => (Object.assign({
        result: (response.data.dataList || []).map(item => {
            return Object.assign(item, {
                backFlag: response.backFlag
            })
        }),
        selects: (response.data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        meta: response.meta,
        checked: false,
        total: response.data.total,
        pageIndex: response.data.pageNum,
        pageSize: response.data.pageSize,
        notify: (response.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const querySearchByName = (keywords ={}) => {
    return fetch.post('eval/result/find/by/realname', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.employeeId,
            employeeNo: d.loginName,
            label: d.doubleName?d.realName+" ("+d.employeeCode+")":d.realName,
        }));
    });
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onResultStateSelect = (ids) => {
    DataGrid.resultStateSelections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getResultStateSelect = () => {
    return DataGrid.resultStateSelections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'eval/result'+ url;
};

const getSelection =() => {
    return DataGrid.selections;
}

export default {
    querySearch,
    headers,
    onSelect,
    setRefresh,
    redirect,
    getSelection,
    onResultStateSelect,
    getResultStateSelect,
    querySearchByName
}